import { render, staticRenderFns } from "./Assistants.vue?vue&type=template&id=d0a1e39c&"
import script from "./Assistants.vue?vue&type=script&lang=js&"
export * from "./Assistants.vue?vue&type=script&lang=js&"
import style0 from "./Assistants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports